// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import styles from './ad_card.module.less';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import Arrow_right from '../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import Anonymity from '../../img/use_cases_card/icons/anonymity.svg';
import Blend from '../../img/use_cases_card/icons/blend.svg';
import Bypass from '../../img/use_cases_card/icons/bypass.svg';
import Consistent from '../../img/use_cases_card/icons/consistent.svg';
import Real_ips from '../../img/use_cases_card/icons/real_ips.svg';
import Stable from '../../img/use_cases_card/icons/stable.svg';
import cn from 'classnames';
import {Editor} from '../../../../shared/editor/editor';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

interface i_ad_card_props {
    use_case: string;
    card_type: string;
    custom_title?: string;
    custom_title_tag?:string;
    custom_button_text?: string;
    img?: string;
}

const use_case_to_image_map = {
    'web-scraping': 'web_scraping',
    'ad-verification': 'ad_verification',
    'price-monitoring': 'price_monitoring',
    'social-media': 'social_media',
    'travel': 'travel',
    'fraud-detection': 'anti_fraud',
    'seo': 'seo',
    'sentiment-analysis': 'sentiment_analysis',
    'product-development': 'product_development',
    'lead-generation': 'lead_generation',
    'sneakers': 'events',
    'proxies-for-ai': 'ai_training',
    'market-research': 'market_research',
    'proxies-for-gaming': 'gaming',
    'academic': 'academic',
    'software-testing': 'software_testing',
    'ecommerce': 'ecommerce',
    'real-estate': 'real_estate',
    'job-scraping': 'job_scraping',
    'crypto': 'crypto',
    'streaming': 'content_streaming',
    'brand-protection': 'brand_protection'
};

export const Ad_card = ({use_case, card_type, custom_title, custom_title_tag,
    custom_button_text, img}: i_ad_card_props)=>{
    const card_data = {
        isp: {
            title: 'Global ISP Proxies',
            features: [
                {
                    title: 'Consistent IP',
                    subtitle: 'fixed, residential IP address',
                    icon: <Consistent/>
                },
                {
                    title: 'Stable Connections',
                    subtitle: 'for long-term, uninterrupted tasks',
                    icon: <Stable/>
                },
                {
                    title: 'Blend In',
                    subtitle: 'they act like real users',
                    icon: <Blend/>
                }
            ],
            button_text: 'Starting at $1.99/IP',
            link: get_new_link('/pricing/isp-proxies')
        },
        rotating: {
            title: 'Rotating Residential Proxies',
            features: [
                {
                    title: 'Real IPs',
                    subtitle: 'genuine devices',
                    icon: <Real_ips/>
                },
                {
                    title: 'High Anonymity',
                    subtitle: 'authentic users, reducing detection',
                    icon: <Anonymity/>
                },
                {
                    title: 'Effective Bypassing',
                    subtitle: 'gets through seamlessly',
                    icon: <Bypass/>
                }
            ],
            button_text: 'Starting at $1.6/IP',
            link: get_new_link('/pricing/residential-proxies')
        }
    };
    const {theme} = useContext(Settings_context);
    const safe_card_type = card_type == 'isp' || card_type == 'rotating' ?
        card_type : 'rotating';
    const data = card_data[safe_card_type];
    const title = custom_title ?? data.title ?? '';
    return <div className={cn(styles.card, theme.container,
      styles[card_type])}>
      <Dynamic_heading tag={custom_title_tag || 'h2'}
        className={cn(styles.title, theme.color_n700)}>
          {title}</Dynamic_heading>
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.features}>
            {data.features.map((feature, index)=>
              <div key={index} className={styles.feature_item}>
                <div className={styles.icon}>
                  {feature.icon}
                </div>
                <div className={styles.feature_text}>
                  <p className={cn(styles.feature_title, theme.mono16,
                    theme.bold, theme.color_n700)}>
                    {feature.title}
                  </p>
                  <p className={cn(styles.feature_subtitle, theme.mono16,
                    theme.med, theme.color_n500)}>
                    {feature.subtitle}
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className={styles.button_wrapper}>
            <Button size='lg' cls={styles.button}
              caption={<Fragment>{custom_button_text ||
                data.button_text}<Arrow_right/></Fragment>}
              round={false} color='black' to={data.link} fit/>
          </div>
        </div>
        <div className={styles.right}>
          <img src={toolip_img_url('use_cases_card/' +
            `${use_case_to_image_map[use_case]}.svg` || img)}
              className={styles.illustration}/>
        </div>
      </div>
    </div>;
};

interface i_ad_card_editor_value {
    custom_title?: string;
    custom_button_text?: string;
    card_type?: string;
    img?: string;
    use_case?: string;
}

interface i_ad_card_editor_props {
    value?: i_ad_card_editor_value;
    on_change: (value: i_ad_card_editor_value)=>void;
}

export const Ad_card_editor = (props: i_ad_card_editor_props)=>{
    const {value = {}, on_change} = props;
    type editor_key = keyof i_ad_card_editor_value;
    type editor_type = 'text';
    const use_case_list = 'web-scraping, ad-verification, price-monitoring, '
        +'social-media, travel, fraud-detection, seo, sentiment-analysis, '
        +'product-development, lead-generation, sneakers, proxies-for-ai, '
        +'proxies-for-gaming, academic, software-testing, ecommerce, '
        +'real-estate, job-scraping, crypto, streaming';
    const editors = [
        ['custom_title', 'Custom Title', 'text'],
        ['custom_title_tag', 'Custom Title Tag', 'select_tag_selector'],
        ['custom_button_text', 'Custom Button Text', 'text'],
        ['card_type', 'Card Type (rotating or isp)', 'text'],
        ['img', 'Image Name', 'text'],
        ['use_case', `Use Case (${use_case_list})`, 'text']
    ].map(([key, label, type])=>({
        key: key as editor_key,
        label,
        type: type as editor_type
    }));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Ad Card Content"
    />;
};
